import { api } from '../api'

export const taskTemplatesApi = api
  .enhanceEndpoints({
    addTagTypes: ['TaskTemplates', 'TaskTemplatesHistory'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      addTaskTemplate: builder.mutation({
        query: (params) => ({
          url: `/task-templates`,
          method: 'POST',
          body: params,
        }),
        invalidatesTags: ['TaskTemplates'],
      }),
      getTaskTemplates: builder.query({
        query: () => ({ url: '/task-templates' }),
        transformResponse: (response) => response?.data || [],
        providesTags: ['TaskTemplates'],
      }),
      deleteTaskTemplate: builder.mutation({
        query: ({ templateId }) => ({
          url: `/task-templates/${templateId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['TaskTemplates'],
      }),
      updateTaskTemplate: builder.mutation({
        query: ({ templateId, params }) => ({
          url: `/task-templates/${templateId}`,
          method: 'PATCH',
          body: params,
        }),
        invalidatesTags: (result, error, { templateId }) => [
          'TaskTemplates',
          { type: 'TaskTemplatesHistory', id: templateId },
        ],
      }),
      getTaskTemplateHistory: builder.query({
        query: (templateId) => ({
          url: `/task-templates/${templateId}/history`,
        }),
        transformResponse: (response) => response?.data || [],
        providesTags: (result, error, templateId) => [
          { type: 'TaskTemplatesHistory', id: templateId },
        ],
      }),
    }),
  })

export const {
  useAddTaskTemplateMutation,
  useGetTaskTemplatesQuery,
  useDeleteTaskTemplateMutation,
  useUpdateTaskTemplateMutation,
  useGetTaskTemplateHistoryQuery,
} = taskTemplatesApi
